import React, {Dispatch, SetStateAction, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {calculateThePot} from './services/pots-calculate.service';
import {PlayerInterface, PotInterface} from './constants/common.interface';
import playerIcon from './assets/player-icon.svg';
import './app.scss';

function App() {
    const {t} = useTranslation('translations');
    const Players: PlayerInterface[] = [
        {
            name: `${t('player').toUpperCase()} 1`,
            betSum: 0,
            index: 1,
        },
        {
            name: `${t('player').toUpperCase()} 2`,
            betSum: 0,
            index: 2,
        },
        {
            name: `${t('player').toUpperCase()} 3`,
            betSum: 0,
            index: 3,
        },
        {
            name: `${t('player').toUpperCase()} 4`,
            betSum: 0,
            index: 4,
        },
        {
            name: `${t('player').toUpperCase()} 5`,
            betSum: 0,
            index: 5,
        },
        {
            name: `${t('player').toUpperCase()} 6`,
            betSum: 0,
            index: 6,
        },
    ];
    const [resultVisibility, setResultVisibility]: [boolean, Dispatch<SetStateAction<boolean>>]
        = useState<boolean>(false);
    const [players, setPlayers]: [PlayerInterface[], Dispatch<SetStateAction<PlayerInterface[]>>]
        = useState<PlayerInterface[]>(Players);
    const [pots, setPots]: [PotInterface[], Dispatch<SetStateAction<PotInterface[]>>]
        = useState<PotInterface[]>([]);
    const lastPot = pots[pots.length - 1];

    const playerFieldChangeHandler = (event: any, index: number): void => {
        const newPlayers: PlayerInterface[] = [...players];
        const newSum = Number(event.target.value);
        if (newSum && newSum > 0) {
            newPlayers[index].betSum = newSum;
            if (newSum < 10000) {
                event.target.value = newSum;
            }
        } else {
            newPlayers[index].betSum = 0;
            event.target.value = '';
        }
        setPlayers(newPlayers);
    };

    const calculatePots = (): void => {
        const activePlayers = players.filter(player => player.betSum);
        if (activePlayers.length) {
            setPots(calculateThePot(activePlayers));
            setResultVisibility(true);
        }
    };

    const getPotsVisibility = (): string => {
        const classNames: string[] = ['pot__wrapper'];
        if (resultVisibility) classNames.push('pot__wrapper_visible');
        return classNames.join(' ');
    };

    const clearAll = (): void => {
        const newPlayers: PlayerInterface[] = players.map((player) => {
            player.betSum = 0;
            return player;
        });
        setPlayers(newPlayers);
    };

    return (
        <div className='app__wrapper'>
            <div className="app">
                <div className='app__title'>
                    {t('chooseTheNumberOfPlayers')}
                </div>
                <div className='app__player-list'>
                    {players.map((player: PlayerInterface, index: number) => {
                        return (
                            <div key={index} className='app__player'>
                                <div className='app__player-left'>
                                    <div className='app__player-name'>
                                        {player.name}
                                    </div>
                                    <div className='app__player-icon'>
                                        <img src={playerIcon} alt='Player Icon'/>
                                    </div>
                                </div>
                                <div className='app__player-field-wrapper'>
                                    <input
                                        className='app__player-field'
                                        value={player.betSum || ''}
                                        type="number"
                                        onChange={(event) => playerFieldChangeHandler(event, index)}
                                    />
                                </div>
                            </div>
                        )
                    })}
                </div>
                <div className='app__calculate-btn' onClick={calculatePots}>
                    {t('calculate')}
                </div>
                <div className='app__clear-btn' onClick={clearAll}>
                    {t('clearAll')}
                </div>
            </div>
            <div className={getPotsVisibility()}>
                <div className="pot">
                    <div className='pot__title'>
                        Side Pot Calculator
                    </div>
                    <div className='pot__list'>
                        {pots.map((pot: PotInterface, index: number) => {
                            if (index + 1 !== pots.length) {
                                return (
                                    <div key={index} className='pot__item'>
                                        <div className='pot__item-left'>
                                            <div className='pot__item-name'>
                                                {pot.name}
                                            </div>
                                            <div className='pot__item-players'>
                                                {`${t('playersIn')} ${pot.name} [${pot.players.join(', ')}]`}
                                            </div>
                                        </div>
                                        <div className='pot__item-sum'>
                                            {pot.sum}$
                                        </div>
                                    </div>
                                )
                            }
                            return <div key={index}/>
                        })}
                    </div>
                    {lastPot && (
                        <div className='pot__result'>
                            {t('resultReturn')} ${lastPot.sum} {t('resultTo')}
                            {lastPot.players.map((playerIndex: number, index: number) =>
                                lastPot.players.length - 1 === index
                                    ? ` ${t('player').toLowerCase()} ${playerIndex}`
                                    : ` ${t('player').toLowerCase()} ${playerIndex},`)}
                        </div>
                    )}
                    <div className='pot__return-btn' onClick={() => setResultVisibility(false)}>
                        {t('returnToBets')}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default App;
